import $ from 'jquery';

$(_ => {

  const $select = $('#donation-form-select-donation-type');
  if ($select.length === 0) return;

  const $addtls = $('.js-data-donation-type-addtl-confirmation');
  const $addtlsContainer = $addtls.first().wrap('<div />').parent();
  $addtls.detach();

  $select.on('change', _ => {
    const val = $select.val();
    const $addtl = $addtls.filter(`[data-donation-type-addtl-confirmation-type="${val}"]`);
    $addtlsContainer.empty().append($addtl);
  });

});